// src/Admin/AcademyWorkspace.js
// Bündelt das Academy-CMS und die Mitgliederverwaltung unter einer
// Navigations-Seite. Eine kleine Unter-Navigation schaltet zwischen
// „Inhalte" (AcademyAdmin) und „Mitglieder" (AcademyMembers) um.
import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import AcademyAdmin from './AcademyAdmin';
import AcademyMembers from './AcademyMembers';
import { pageVariants } from './dashboardMotion';
import './AcademyWorkspace.css';

const IconContent = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="m2 17 10 5 10-5" /><path d="m2 12 10 5 10-5" />
  </svg>
);
const IconMembers = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const SUBTABS = [
  { id: 'content', label: 'Inhalte', icon: <IconContent /> },
  { id: 'members', label: 'Mitglieder', icon: <IconMembers /> },
];

const AcademyWorkspace = () => {
  const [view, setView] = useState('content');

  return (
    <div className="aw-wrap">
      <div className="aw-subnav">
        <div className="aw-subtabs">
          {SUBTABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`aw-subtab ${view === tab.id ? 'aw-subtab-active' : ''}`}
              onClick={() => setView(tab.id)}
            >
              {view === tab.id && (
                <motion.span
                  layoutId="aw-subtab-pill"
                  className="aw-subtab-pill"
                  transition={{ type: 'spring', stiffness: 380, damping: 32 }}
                />
              )}
              <span className="aw-subtab-label">
                <span className="aw-subtab-icon">{tab.icon}</span>
                {tab.label}
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="aw-body">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={view}
            className="aw-page"
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {view === 'content' && <AcademyAdmin />}
            {view === 'members' && <AcademyMembers />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AcademyWorkspace;
